import { useSelector } from 'react-redux';

import { getAccessConfiguration } from 'src/apps/NewDriverApp/hooks/useExtendedPermissions/utils/getAccessConfiguration';
import { getExtendedPermissions } from 'src/apps/NewDriverApp/redux/selectors';

export const useExtendedPermissions = () => {
  const permissions = useSelector(getExtendedPermissions);
  return getAccessConfiguration(permissions);
};
